import { render, staticRenderFns } from "./PopupFormPrbm.vue?vue&type=template&id=cdcedfe2&"
import script from "./PopupFormPrbm.vue?vue&type=script&lang=js&"
export * from "./PopupFormPrbm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports